import { render, staticRenderFns } from "./account-set.vue?vue&type=template&id=71fd315f&scoped=true&"
import script from "./account-set.vue?vue&type=script&lang=js&"
export * from "./account-set.vue?vue&type=script&lang=js&"
import style0 from "./account-set.vue?vue&type=style&index=0&id=71fd315f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd315f",
  null
  
)

export default component.exports